import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import qs from 'query-string';

import getEnvConfig from 'utils/config/env';

import { IStatisticMessages } from './messages.interface';
import { AnalyticsFiltersProps } from '../../AnalyticsFilters/service/filters.interface';

export const analyticsMessagesApi = createApi({
    reducerPath: 'analyticsMessages',
    baseQuery: fetchBaseQuery({
        baseUrl: getEnvConfig().env.API_URL,
        prepareHeaders: headers => {
            const token = localStorage.getItem('accessToken');
            headers.set('Authorization', `Bearer ${token}`);
            return headers;
        },
    }),
    tagTypes: ['AnalyticsMessages'],
    endpoints: builder => ({
        getMessages: builder.query<IStatisticMessages, AnalyticsFiltersProps>({
            query: args => {
                const queryArgs = qs.stringify(args, {
                    arrayFormat: 'bracket',
                    skipNull: true,
                });
                return {
                    url: `/statistic/messages/charts?${queryArgs}`,
                    method: 'GET',
                };
            },
            transformResponse: (response: { data: IStatisticMessages }) => {
                return response.data;
            },
        }),
        getSemantics: builder.query<IStatisticMessages, AnalyticsFiltersProps>({
            query: args => {
                const queryArgs = qs.stringify(args);
                return {
                    url: `/statistic/semantic/charts?${queryArgs}`,
                    method: 'GET',
                };
            },
            transformResponse: (response: { data: IStatisticMessages }) => {
                return response.data;
            },
        }),
    }),
});

export const { useLazyGetMessagesQuery, useGetSemanticsQuery } =
    analyticsMessagesApi;
